import { Container } from "react-bootstrap";
import styled from "styled-components";

export const MainContainer = styled(Container)`
  position:relative;
  @media screen and (max-width: 1400px) {
    max-width: unset;
  }

  @media screen and (min-width: 1400px) {
    max-width: 1520px;
  }
`;
export const MainContentWrapper =  styled.div`
  display: flex;
  align-items: ${({ align_items }) => align_items};
  justify-content: ${({ justify_content }) => justify_content};
  gap: ${({ gap }) => gap};
   min-height: ${({ headerHeight = 76 }) => `calc(100dvh - ${headerHeight}px - 15px)`};
`;
export const ContentContainer = styled.div`
  flex: 1;
  min-width: 0; 
  /* margin-bottom: 10px; */
`;
